export default {
  'label/sharing': 'Compartiendo...',
  'label/shared_ok': 'Listo.',
  'label/close': 'Cerrar',
  'label/view': 'Ver',
};
